// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./insa-css/insa-clients/FIO/insa-kendo-css/kendo.custom.css
// module id = 1882
// module chunks = 2